import * as Yup from "yup";
import { IValidationProps } from "./type";

const validateForm = (props: IValidationProps) => {
  const { isMin8, isAlpha, isNum, isReMin8, isReAlpha, isReNum } = props;
  let schema = {};

  schema = Yup.object().shape({
    newPassword: Yup.string()
      .required("")
      .test("password-test", "", () =>
        [isMin8, isAlpha, isNum].every((item: boolean) => item),
      ),
    reEnterNewPassword: Yup.string()
      .required("")
      .test("repassword-test", "", () =>
        [isReMin8, isReAlpha, isReNum].every((item: boolean) => item),
      ),
  });

  return schema;
};

export default validateForm;
